import { Suspense, ComponentType, ReactNode } from 'react';
import { RotateLoader } from 'react-spinners';
import { PageWrapper } from '../PageWrapper';
import { OrderPageSkeleton } from '../Skeletons/OrderSkeletons';
import { AppErrorBoundary } from '../ErrorBoundary';
import { useLocation } from 'react-router-dom';

const LoadingIndicator = ({ route }: { route?: string }) => {
  if (route !== undefined && route.startsWith('/order/')) {
    return <OrderPageSkeleton />;
  }
  return (
    <div
      className="d-flex justify-content-center align-items-center h-100"
      style={{ minHeight: '200px' }}
    >
      <RotateLoader />
    </div>
  );
};

interface WrapperProps {
  component: ComponentType;
  withPageWrapper?: boolean;
}

export const LazyWrapper = ({
  component: Component,
  withPageWrapper = true
}: WrapperProps): ReactNode => {
  const location = useLocation();
  const content = (
    // Пер-страничный boundary внутри layout: краш контента страницы не ломает
    // сайдбар/шапку. resetKeys=[pathname] — при переходе на другой маршрут
    // fallback сбрасывается автоматически.
    <AppErrorBoundary scope="page" resetKeys={[location.pathname]}>
      <Suspense fallback={<LoadingIndicator route={location.pathname} />}>
        <Component />
      </Suspense>
    </AppErrorBoundary>
  );

  return withPageWrapper ? <PageWrapper>{content}</PageWrapper> : content;
};
